import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {mailingListEdit_template} from "../components/templates/mailingListEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class mailing_list_edit extends vnModule_knockoutJS{
    protected mailingListEdit : mailingListEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.mailingListEdit = new mailingListEdit_template('mailingListEdit', this.viewModel, this)
        return [this.mailingListEdit.build()]
    }

    protected getModuleName(): string {
        return "mailing_list_edit";
    }

    public fillPage() {
        this.getMailingListReferences();
    }


    protected getMailingListReferences() {

        // LOADING : starts
        this.loadingIn(this.mailingListEdit.builtTemplate);

        let usrReq_url: string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/mailingList/references/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onMailingListReferenceRequestReturn;
        this.XHRHdl.execute();
    }

    protected onMailingListReferenceRequestReturn(req, obj) {

        return function () {
            obj.manageResponse(req, obj, function () {

                obj.loadingOut(obj.mailingListEdit.builtTemplate);

                //check if user has article write permissions
                let responseParsed = JSON.parse(req.request.response);

                obj.setInteractionEmails(responseParsed.emails)
                obj.getMailingListDataForEdit();
            })
        }
    }

    public setInteractionEmails(interactionEmails) {

        let welcomeEmailOptions = [{'id':null,'name':'None'}];
        let unsubscriptionEmailOptions = [{'id':null,'name':'None'}];

        for (let interactionEmail of interactionEmails) {

            if(interactionEmail.type.name == 'Welcome') {

                welcomeEmailOptions.push( {
                    id: interactionEmail.id,
                    name: interactionEmail.subject + '(' + interactionEmail.id + ')'
                })
            }

            if(interactionEmail.type.name == 'Unsubscription') {

                unsubscriptionEmailOptions.push( {
                    id: interactionEmail.id,
                    name: interactionEmail.subject + '(' + interactionEmail.id + ')'
                })
            }
        }

        this.mailingListEdit.setWelcomeEmails(welcomeEmailOptions);
        this.mailingListEdit.setUnsubscriptionEmails(unsubscriptionEmailOptions);
    }

    public getMailingListDataForEdit() {

        this.loadingIn(this.mailingListEdit.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/mailingList/get/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetMailingListDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetMailingListDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                obj.setMailingListData(responseParsed.data);
            });

            obj.loadingOut(obj.mailingListEdit.builtTemplate);
        }
    }

    protected setMailingListData(mailingList) {
        this.mailingListEdit.setId(mailingList.id)
        this.mailingListEdit.setName(mailingList.name)
        this.mailingListEdit.setDescription(mailingList.description)
        this.mailingListEdit.setIsActive((mailingList.isActive) ? true : false)
        this.mailingListEdit.setIsPrimary((mailingList.isPrimary) ? true : false)
        this.mailingListEdit.setReference(mailingList.reference)
        this.mailingListEdit.setIsDefault((mailingList.isDefault) ? true : false)
        
        //set welcome and unsubscription emails
        this.mailingListEdit.welcomeEmailSelector.setSelectedOption(mailingList.welcomeEmailId)
        this.mailingListEdit.unsubscriptionEmailSelector.setSelectedOption(mailingList.unsubscriptionEmailId)
        if(mailingList.isPrimary){
            this.mailingListEdit.welcomeEmailSelector.setDisable(false)
            this.mailingListEdit.unsubscriptionEmailSelector.setDisable(false)
        }
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/mailing-lists/")
    }


    protected save(){
        this.loadingIn(this.mailingListEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/mailingList/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.mailingListEdit.getViewModelForRequest()));
        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/newsletter/mailing-lists/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Mailing list saved !");
                        //obj.getVnAppZone().showNotificationToModule();
                    }

                });
                obj.loadingOut(obj.mailingListEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }

    public filterDropdownOnChange(idElement){

    }
}


// WEBPACK FOOTER //
// ./js/modules/mailing_list_edit.ts